export default function getInitState() {
    return {
        formIsOpen: false,
        gridIsOpen: true,
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        actions: [
            {
                btn_text: '<i class="fas fa-plus"></i> Új engedély',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newRow'
            }
        ],
        formActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToGrid'
            },
            {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetForm'
            },
            {
                btn_text: '<i class="fas fa-print"></i> Mentés',
                event_name: "customClick",
                class: "btn btn-success my-custom-class mx-1",
                event_payload: 'save'
            }
        ],
        rowActions: [
            {
                btn_text: '<i class="fas fa-redo"></i> EESZT-be küldés',
                title: 'Beküldés EESZT-be',
                event_name: "customClick",
                class: "btn btn-teal",
                additionalButtonVisible: "canSendEeszt",
                event_payload: 'sendEESZT'
            },
            {
                btn_text: '<i class="fas fa-trash"></i> EESZT törlés',
                title: 'EESZT törlés',
                event_name: "customClick",
                class: "btn btn-danger",
                additionalButtonVisible: "canDeleteEeszt",
                event_payload: 'deleteEESZT'
            },
            {
                btn_text: 'Validálás és beküldés',
                title: 'Validálás',
                event_name: "customClick",
                class: "btn btn-outline-teal",
                event_payload: 'showValidatePopup',
                additionalButtonVisible: "isDocumentValidated",
            },
            {
                btn_text: '<i class="fas fa-print"></i>',
                title: 'Nyomtatás',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'printRow'
            },
            {
                btn_text: '<i class="fas fa-print"></i>',
                title: 'Nyomtatás EESZT - Kézbesítési igazolás',
                event_name: "customClick",
                class: "btn btn-outline-info",
                additionalButtonVisible: "isShowPrintDriverLicenseEeszt",
                event_payload: 'printEESZTKezbesitesiIgazolasRow'
            },
            {
                btn_text: '<i class="fas fa-print"></i>',
                title: 'Nyomtatás EESZT - Vezetői engedély feldolgozási eredmény',
                event_name: "customClick",
                class: "btn btn-outline-info",
                additionalButtonVisible: "isShowPrintDriverLicenseEeszt",
                event_payload: 'printEESZTVezetoiEngedelyRow'
            },
            {
                btn_text: '<i class="fas fa-history"></i>',
                title: 'Előzmények',
                event_name: "customClick",
                class: "btn btn-outline-purple",
                event_payload: 'showHistory'
            },
            {
                btn_text: '<i class="far fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyRow',
                additionalButtonVisible: "isDocumentValidated",
            },
            {
                btn_text: '<i class="fas fa-unlock"></i>',
                title: 'Felnyitás',
                event_name: "customClick",
                class: "btn btn-outline-info",
                event_payload: 'seeEdit',
                additionalButtonVisible: "isDocumentValidatedReopen",
            },
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteRow',
                additionalButtonVisible: "isDocumentValidated",
            },
            {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeleteRow',
            },
        ],
        headerFields: [
            {
                name: "treatment.startDate",
                label: "Kezelés időpontja",
                slot_name: "startDate_format",
                visibility: true,
                formType: "date"
            },
            {
                name: "level.text",
                label: "Fok",
                visibility: true
            },
            {
                name: "driverLicenseType.text",
                label: "Vezetői engedély típus",
                visibility: true
            },
            {
                name: "examinationType.text",
                label: "Vizsgálat típus",
                visibility: true
            },
            {
                name: "examinationGoal.text",
                label: "Vizsgálat célja",
                visibility: true
            },
            // {
            //     name: "opinionType.text",
            //     label: "Vélemény típus",
            //     visibility: true
            // },
            {
                name: "capableStatus.text",
                label: "Alkalmasság",
                visibility: true
            },
            {
                name: "nextExaminationDate",
                label: "Következő vizsgálat",
                slot_name: "date_format",
                sort: true,
                visibility: true
            },
            {
                name: "createdBy",
                label: "Létrehozó",
                visibility: true
            },
            {
                name: "createdOn",
                label: "Létrehozás időpontja",
                slot_name: "created_on_format",
                sort: true,
                visibility: true
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ]
    }
}
